import React from 'react';

// CRA only exposes REACT_APP_* vars to the client bundle
const ENABLE_WDYR = process.env.REACT_APP_ENABLE_WDYR === 'true';

if (ENABLE_WDYR) {
  console.log(
    '%c(why-did-you-render is ACTIVE)',
    'font-size: 1.2rem; color: #222; background: #f1faee; padding: 4px 12px; border-radius: 3px;'
  );
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}
